import api from '../config/axiosConfig';

export const ProductService = {
    getProducts: async ({ token, pagina = 1, pageSize = 20, nombre = '' }) => {
        try {
            const response = await api.get('/productos', {
                headers: { Authorization: `Bearer ${token}` },
                params: { pagina, pageSize, nombre },
            });

            return {
                productos: response.data.products || [],
                totalPaginas: response.data.totalPaginas || 1,
                totalRegistros: response.data.totalRegistros || 0,
            };
        } catch (error) {
            console.error('Error en ProductService.fetchProductos:', error);
            throw error;
        }
    },
    toggleEstadoProducto: async ({ token, producto }) => {
        try {
            const nuevoEstado = producto.estado === 'ACTIVO' ? 'BAJA' : 'ACTIVO';

            await api.put(`/productos/${producto.id}`,
                { estado: nuevoEstado },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            return nuevoEstado; 
        } catch (error) {
            console.error('Error en ProductService.toggleEstadoProducto:', error);
            throw error;
        }
    },
    registrarProducto: async ({ token, form }) => {
        try {
            await api.post('/productos', form, {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            console.error('Error en ProductService.registrarProducto:', error);
            throw error;
        }
    },
    fetchProductoPorId: async ({ token, id }) => {
        try {
            const response = await api.get(`/productos/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            return response.data;
        } catch (error) {
            console.error('Error en ProductService.fetchProductoPorId:', error);
            throw error;
        }
    },
    editarProducto: async ({ token, id, form }) => {
        try {
            await api.put(`/productos/${id}`, form, {
                headers: { Authorization: `Bearer ${token}` },
            });
        } catch (error) {
            console.error('Error en ProductService.editarProducto:', error);
            throw error;
        }
    },
    fetchProductosPorCategoria: async (token, categoriaId, marcaId = null) => {
        try {
            const params = {};
            if (marcaId) {
                params.marca_id = marcaId;
            }
            const response = await api.get(`/productos/categoria/${categoriaId}`, {
                headers: { Authorization: `Bearer ${token}` },
                params,
            });

            return response.data?.data || [];
        } catch (error) {
            console.error('Error en ProductoService.fetchProductosPorCategoria:', error);
            throw error;
        }
    },
};
